import { components } from "@/api-schema";

type Branch = components["schemas"]["Branch"];

export const mergeAndFilterBranches = (
  mainBranch: Branch | null | undefined,
  assignedBranches: Branch[] | undefined,
): Branch[] => {
  const candidates = [mainBranch, ...(assignedBranches ?? [])];

  const seen = new Set<string>();

  return candidates.filter((branch): branch is Branch => {
    if (branch == null) return false;
    if (seen.has(branch.technicalId)) return false;

    seen.add(branch.technicalId);

    return true;
  });
};
